import { toast } from 'react-hot-toast';
import { useMutation } from '@tanstack/react-query';

import { request } from '@core/api/request';
import { queryClient } from '@core/api/query-client';
import { QUERY_KEYS } from '@src/shared/constants/query-keys';
import type { TEmergencyContactInfo } from '@shared/types/member';

export const editUserEContactInfo = async ({
  userId,
  ...data
}: TEmergencyContactInfo & { userId: number }) => {
  const id = data.id;
  return await request({
    url: id
      ? `members/${userId}/emergency-contact-info/${data.id}`
      : `members/${userId}/emergency-contact-info/`,
    method: id ? 'PATCH' : 'POST',
    body: data,
  });
};

export const useEditUserEContactInfo = () => {
  return useMutation({
    mutationFn: editUserEContactInfo,
    onError: (error: string) => {
      toast.error(error);
    },
    onSuccess: () => {
      toast.success('User Emergency Contact Info has updated successfully.');
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.getUserById],
      });
    },
  });
};
